import React, { useEffect, useState } from 'react';
import { Grid } from '@material-ui/core';
import {
  StyledCaptions,
  ItemWrapper,
  ContentWrapper,
  StyledIcon,
  StyledSmallIcon,
  CategoryCaptions,
} from 'components/ListBoxItem/styles';
import { AssuranceIcon } from 'images';
import { IntlShape, injectIntl } from 'react-intl';
import { darkBlue, sanlamDarkBlue, white } from 'Material-UI/colors';
import { connect, useDispatch } from 'react-redux';
import messages from 'containers/AmcDetailsPage/messages';
import { createStructuredSelector } from 'reselect';
import { translate } from 'helpers/intl';
import HelpOutlineIcon from '@material-ui/icons/HelpOutline';
import PersonAddIcon from '@material-ui/icons/PersonAdd';
import { isEmpty } from 'lodash';
import { updatePACObject } from 'store/pac/actions';
import AddBeneficiaryHelpText from './AddBeneficiaryHelpText';

type ListBoxItemType = {
  items: any;
  isBeneficiaryBloc?: boolean;
  intl: IntlShape;
  organismeListPac: any[];
  selectedContract: any;
  openModalPAC: Function;
};
const ListBoxItem = ({ ...props }: ListBoxItemType) => {
  const [open, setOpen] = useState(false);

  const dispatch = useDispatch();
  const client =
    props.items &&
    props.items.filter((beneficiary: any) =>
      beneficiary.categorie.includes('AS'),
    );
  const partners =
    props.items &&
    props.items.filter((beneficiary: any) =>
      beneficiary.categorie.includes('C'),
    );
  const childs =
    props.items &&
    props.items.filter(
      (beneficiary: any) =>
        !beneficiary.categorie.includes('AS') &&
        !beneficiary.categorie.includes('C'),
    );

  const hasPac = () => {
    const pacPolicy = props.organismeListPac?.find(
      /* istanbul ignore next */ (organisme) =>
        organisme?.NUM_POLICE === props.selectedContract?.numeroPolice,
    );
    if (
      pacPolicy &&
      (pacPolicy.NATURE_POLICE === 'DIM' || pacPolicy.NATURE_POLICE === 'CNSS')
    ) {
      /* istanbul ignore next */
      return false;
    }
    return !isEmpty(pacPolicy) && props.selectedContract.etatAdh !== 'RD';
  };

  useEffect(() => {
    if (props.selectedContract?.member) {
      /* istanbul ignore next */
      dispatch(
        updatePACObject({
          NomPrenomADH: props.selectedContract?.member,
        }),
      );
    }
  }, [props.selectedContract]);

  const getPacLabel = (categorie: string) => {
    if (categorie === 'AS') {
      return translate({ ...messages.adherant }, props);
    } else if (categorie.includes('C')) {
      return translate({ ...messages.conjoint }, props);
    } else {
      return translate({ ...messages.enfant }, props);
    }
  };

  return (
    <>
      <AddBeneficiaryHelpText open={open} setOpen={setOpen} />
      <Grid spacing={1} container>
        {props.isBeneficiaryBloc && !hasPac() && (
          <Grid
            item
            xs={6}
            sm={4}
            lg={2}
            onClick={/* istanbul ignore next */ () => setOpen(true)}
          >
            <ItemWrapper coloredBackground={true} data-testid="menu_item">
              <ContentWrapper>
                <HelpOutlineIcon style={{ color: white }} />
                <StyledCaptions weight="500" color={'white'}>
                  {translate({ ...messages.howAddBenificiary }, props)}
                </StyledCaptions>
              </ContentWrapper>
            </ItemWrapper>
          </Grid>
        )}
        {
          /* istanbul ignore next */ hasPac() && (
            <Grid item xs={6} sm={4} lg={2}>
              <ItemWrapper
                onClick={() => props.openModalPAC()}
                data-testid="menu_item"
                style={{
                  borderWidth: 4,
                  borderColor: '#F9AA01',
                  borderStyle: 'solid',
                  borderRadius: '5px',
                }}
              >
                <span
                  style={{
                    fontSize: 10,
                    position: 'absolute',
                    color: 'white',
                    fontFamily: 'Roboto',
                    paddingRight: 8,
                    paddingLeft: 8,
                    backgroundColor: '#F9AA01',
                    boxSizing: 'border-box',
                    borderBottomLeftRadius: '5px',
                    marginRight: '20px',
                  }}
                >
                  {props.intl.formatMessage({ id: 'menu.item.new' })}
                </span>
                <ContentWrapper>
                  <PersonAddIcon style={{ color: '6FAD37' }} />
                  <StyledCaptions weight="500" color={sanlamDarkBlue}>
                    {translate({ ...messages.declarPac }, props)}
                  </StyledCaptions>
                </ContentWrapper>
              </ItemWrapper>
            </Grid>
          )
        }
        {client &&
          client.map(
            (
              item: {
                path: string;
                icon: string;
                title: string;
                smalIcon?: Boolean;
                category: string;
                label: string;
                categorie: string;
              },
              index: number,
            ) => (
              <Grid item xs={6} sm={4} lg={2} key={index}>
                <ItemWrapper coloredBackground={false} data-testid="menu_item">
                  <ContentWrapper>
                    {item.smalIcon ? (
                      <StyledSmallIcon src={AssuranceIcon[item.icon]} />
                    ) : (
                      <StyledIcon src={AssuranceIcon[item.icon]} />
                    )}
                    <StyledCaptions weight="500" color={darkBlue}>
                      {item.title}
                    </StyledCaptions>
                    <CategoryCaptions color={darkBlue}>
                      {getPacLabel(item.categorie)}
                    </CategoryCaptions>
                  </ContentWrapper>
                </ItemWrapper>
              </Grid>
            ),
          )}
        {partners &&
          partners.map(
            (
              item: {
                path: string;
                icon: string;
                title: string;
                smalIcon?: Boolean;
                category: string;
                label: string;
                categorie: string;
              },
              index: number,
            ) => (
              <Grid item xs={6} sm={4} lg={2} key={index}>
                <ItemWrapper coloredBackground={false} data-testid="menu_item">
                  <ContentWrapper>
                    {item.smalIcon ? (
                      <StyledSmallIcon src={AssuranceIcon[item.icon]} />
                    ) : (
                      <StyledIcon src={AssuranceIcon[item.icon]} />
                    )}
                    <StyledCaptions weight="500" color={darkBlue}>
                      {item.title}
                    </StyledCaptions>
                    <CategoryCaptions color={darkBlue}>
                      {getPacLabel(item.categorie)}
                    </CategoryCaptions>
                  </ContentWrapper>
                </ItemWrapper>
              </Grid>
            ),
          )}
        {childs &&
          childs.map(
            (
              item: {
                path: string;
                icon: string;
                title: string;
                smalIcon?: Boolean;
                category: string;
                label: string;
                categorie: string;
              },
              index: number,
            ) => (
              <Grid item xs={6} sm={4} lg={2} key={index}>
                <ItemWrapper coloredBackground={false} data-testid="menu_item">
                  <ContentWrapper>
                    {item.smalIcon ? (
                      <StyledSmallIcon src={AssuranceIcon[item.icon]} />
                    ) : (
                      <StyledIcon src={AssuranceIcon[item.icon]} />
                    )}
                    <StyledCaptions weight="500" color={darkBlue}>
                      {item.title}
                    </StyledCaptions>
                    <CategoryCaptions color={darkBlue}>
                      {getPacLabel(item.categorie)}
                    </CategoryCaptions>
                  </ContentWrapper>
                </ItemWrapper>
              </Grid>
            ),
          )}
      </Grid>
    </>
  );
};

const mapStateToProps = createStructuredSelector<any, {}>({});

export default connect(mapStateToProps)(injectIntl(ListBoxItem));
export { ListBoxItem };
